var map = {
	"./2018/IMG_1127.JPEG": 9908,
	"./2018/IMG_1128.JPEG": 9369,
	"./2018/IMG_1129.JPEG": 9490,
	"./2018/IMG_1130.JPEG": 4291,
	"./2019/IMG_1118.JPEG": 6175,
	"./2019/IMG_1119.JPEG": 1000,
	"./2019/IMG_1123.JPEG": 1561,
	"./2019/IMG_1125.JPEG": 2387,
	"./2021/IMG_1117.JPEG": 5815,
	"./2021/IMG_9067.JPEG": 2979,
	"./2021/IMG_9068.JPEG": 3386,
	"./2021/IMG_9069.JPEG": 9953,
	"./2022/IMG_2802.JPEG": 7178,
	"./2022/P1051207.JPEG": 6456,
	"./2022/P1062465.JPEG": 5548,
	"./2022/P1063607.JPEG": 4887,
	"./2022/P1064031.JPEG": 8715,
	"./2023/DSC04844.JPEG": 2349,
	"./2023/DSC04883.JPEG": 2828,
	"./2023/IMG_4418.JPEG": 1034,
	"./2023/IMG_5080.JPEG": 7054,
	"./2023/IMG_9055.JPEG": 7676,
	"./2023/IMG_9063.JPEG": 6497,
	"./2023/IMG_9999.jpg": 3619,
	"./2024/DSC_0207.JPG": 8015,
	"./2024/IMG_0538.JPG": 7259,
	"./2024/IMG_3687.JPG": 4199,
	"./2024/IMG_4046.JPG": 1569,
	"./2024/IMG_5547.JPG": 3162,
	"./2024/IMG_9389.JPG": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9001;